import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatInputModule, MatAutocompleteModule, MatSlideToggleModule, MatIconModule, MatButtonModule, MatDialogModule, MatSnackBarModule, MatRadioModule,
         MatDatepickerModule, MatNativeDateModule, MatSelectModule, MatFormFieldModule } from '@angular/material';

import { SnackbarComponent } from './snackbar.component';
import { SnackbarService } from './service/snackbar.service';
import { NotificationService } from '../service/notification.service';

@NgModule({
    imports: [
    	BrowserModule, FormsModule, ReactiveFormsModule, BrowserAnimationsModule, CommonModule, BrowserModule, HttpModule,
        MatInputModule, MatAutocompleteModule, MatSlideToggleModule, MatIconModule, MatButtonModule, MatDialogModule,
        MatSnackBarModule, MatRadioModule,
        MatDatepickerModule, MatNativeDateModule, MatSelectModule, MatFormFieldModule
    ],
    entryComponents: [],
    exports: [SnackbarComponent],
    declarations: [
        SnackbarComponent
    ],
    providers: [NotificationService, SnackbarService],
    bootstrap: []
})

export class SnackbarModule {}
